import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import isEmpty from 'is-empty';
import classNames from 'classnames';
import Formatters from '../../shared/utils/Formatters';

class LoanPlan extends Component {
  get loanPlanType() {
    return this.props.type === 'POFinancingLoanPlan'
      ? 'Purchase Order'
      : 'Invoice';
  }

  actionPath() {
    if (this.props.is_setup_complete) {
      return {
        pathname: `/loan_plan_overview/${this.props.id}`,
      };
    } else {
      return {
        pathname: `/pending_loan_offers/${this.props.loan_offer_id}/accepted`
      }
    }
  }

  renderBuyerName = () => {
    if (isEmpty(this.props.buyer_name)) return;
  };

  renderActionLabel = () => {
    return !this.props.is_setup_complete ? 'Continue' : 'Details';
  };

  actionClassNames = () => {
    return classNames('ds-btn', '--small', '_simple', '_widthAuto', {
      '-secondary': this.props.is_percentage_completed,
    });
  };

  render() {
    return (
      <div className="ds-card">
        <section className="cardSection _withColumns _simple">
          <div className="ds-data">
            <small className="dataName">{this.props.buyer_name}</small>
            <p className="data">
              <span className="sub">₱</span>{' '}
              {Formatters.amount({ amount: this.props.loan_size })}
            </p>
            <small className="ds-status">{this.loanPlanType}</small>
          </div>
            <Link to={this.actionPath()}
              data-testid="loan-plan-next-button"
              className={this.actionClassNames()}
              onClick={this.props.onClick}>
              {this.renderActionLabel()}
            </Link>
        </section>
        <div className="cardSection _footer ds-data">
          <p className="data">
            <span className="sub">Loan Term: {this.props.display_title}</span>
          </p>
        </div>
      </div>
    );
  }
}

export default LoanPlan;



// WEBPACK FOOTER //
// ./src/features/loans/components/LoanPlan.js